/* Kalve "Get the full look" (sections/kalve-full-look.liquid). Vanilla, no dependencies.
   The section prints every price, photo and variant id for both finishes (JSON blob [data-k-look-data]); this file only toggles
   classes and text, drives the phone carousel dots and adds the 3 variants through
   window.KalveCart.add([...]) (assets/kalve-cart.js; it opens the drawer). Without KalveCart the form posts to /cart/add as is. */
(function () {
  'use strict';
  if (window.KalveLook) { window.KalveLook.scan(); return; }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function Look(root) {
    this.root = root;
    this.row = $('[data-k-look-row]', root);
    this.model = $('[data-k-look-model]', root);
    this.cards = $$('[data-k-look-card]', root);
    this.dots = $$('[data-k-look-dots] i', root);
    this.form = $('[data-k-look-form]', root);
    this.addBtn = $('[data-k-look-add]', root);
    this.total = $('[data-k-look-total]', root);
    this.note = $('[data-k-look-note]', root);
    this.finName = $('[data-k-look-finname]', root);
    this.ids = $$('[data-k-look-id]', root);
    this.fin = 'gold';
    this.busy = false;
    this.flash = '';
    this.timers = {};
    var blob = $('[data-k-look-data]', root);
    try { this.data = JSON.parse(blob.textContent); } catch (e) { return; }
    this.strings = this.data.strings || {};
    this.bind();
    root.classList.add('is-ready');
    this.setFin('gold');
    this.updateDots();
  }

  Look.prototype.bind = function () {
    var self = this;

    /* finish radios: the head toggle and the one on every card share one state */
    $$('[data-k-look-fins]', this.root).forEach(function (group) {
      group.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-k-look-fin]') : null;
        if (b && group.contains(b)) self.setFin(b.getAttribute('data-k-look-fin'));
      });
      group.addEventListener('keydown', function (e) {
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
        e.preventDefault();
        var next = self.fin === 'gold' ? 'silver' : 'gold';
        self.setFin(next);
        var b = $('[data-k-look-fin="' + next + '"]', group);
        if (b) b.focus();
      });
    });

    if (this.row) this.row.addEventListener('scroll', function () { self.updateDots(); }, { passive: true });

    if (this.form) this.form.addEventListener('submit', function (e) { self.submit(e); });
  };

  /* ---------- finish ---------- */
  Look.prototype.setFin = function (f) {
    var d = this.data.fin[f];
    if (!d) return;
    this.fin = f;
    this.root.setAttribute('data-fin', f);
    $$('[data-k-look-fin]', this.root).forEach(function (b) {
      var on = b.getAttribute('data-k-look-fin') === f;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    $$('.k-look__img, .k-look__mimg', this.root).forEach(function (im) {
      im.classList.toggle('is-on', im.classList.contains('k-look__img--' + f) || im.classList.contains('k-look__mimg--' + f));
    });
    var items = this.data.items || [];
    this.cards.forEach(function (c, i) {
      var it = items[i] && items[i][f];
      if (!it) return;
      var price = $('[data-k-look-price]', c), mat = $('[data-k-look-mat]', c);
      if (price) price.textContent = it.price;
      if (mat) { mat.textContent = it.mat; mat.hidden = !it.mat; }
    });
    if (this.finName) this.finName.textContent = d.label;
    if (this.total) this.total.textContent = d.total;
    var ids = (d.ids || '').split(',');
    this.ids.forEach(function (inp, i) { if (ids[i]) inp.value = ids[i]; });
    this.paintButton();
    this.paintNote();
  };

  Look.prototype.soldOut = function () { return !!(this.data.fin[this.fin] && this.data.fin[this.fin].note); };

  Look.prototype.paintButton = function () {
    var b = this.addBtn;
    if (!b) return;
    var sold = this.soldOut();
    b.disabled = sold || this.busy;
    b.classList.toggle('is-busy', this.busy);
    if (this.busy) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    var label = this.strings.add;
    if (sold) label = this.strings.soldOut;
    else if (this.flash === 'adding') label = this.strings.adding;
    else if (this.flash === 'added') label = this.strings.added;
    b.textContent = label;
  };

  /* one polite live region: add errors / confirmation win over the standing sold-out note */
  Look.prototype.paintNote = function () {
    if (!this.note) return;
    var msg = this.message || (this.data.fin[this.fin] && this.data.fin[this.fin].note) || '';
    if (this.note.textContent !== msg) this.note.textContent = msg;
  };

  /* ---------- phone carousel dots (visual order on phones: model tile, then the cards) ---------- */
  Look.prototype.updateDots = function () {
    if (!this.dots.length || !this.row) return;
    var ordered = [this.model].concat(this.cards);
    var pad = parseFloat(getComputedStyle(this.row).paddingLeft) || 0, best = 0, bd = 1e9, row = this.row;
    ordered.forEach(function (el, i) {
      if (!el) return;
      var d = Math.abs(el.offsetLeft - pad - row.scrollLeft);
      if (d < bd) { bd = d; best = i; }
    });
    if (row.scrollLeft + row.clientWidth >= row.scrollWidth - 2) best = ordered.length - 1;
    this.dots.forEach(function (x, i) { x.classList.toggle('is-on', i === best); });
  };

  /* ---------- add all 3 ---------- */
  Look.prototype.submit = function (e) {
    var self = this;
    if (this.busy) { e.preventDefault(); return; }
    if (this.soldOut()) { e.preventDefault(); return; }
    var d = this.data.fin[this.fin];
    var ids = (d.ids || '').split(',').filter(Boolean);
    if (!(window.KalveCart && typeof window.KalveCart.add === 'function') || !ids.length) return; /* plain POST fallback */
    e.preventDefault();
    this.busy = true;
    this.flash = 'adding';
    this.message = '';
    this.paintButton();
    this.paintNote();
    window.KalveCart.add(ids.map(function (id) { return { id: Number(id), quantity: 1 }; })).then(function () {
      self.busy = false;
      self.flash = 'added';
      self.message = self.strings.added;
      self.paintButton();
      self.paintNote();
      clearTimeout(self.timers.reset);
      self.timers.reset = setTimeout(function () { self.flash = ''; self.message = ''; self.paintButton(); self.paintNote(); }, 1800);
    }).catch(function (err) {
      self.busy = false;
      self.flash = '';
      self.message = (err && err.message) || self.strings.error;
      self.paintButton();
      self.paintNote();
    });
  };

  /* On a collection page the look sits INSIDE the product grid, as a full-width row after the first 4 cards
     (#product-grid is Dawn's <ul>). With 4 cards or fewer it stays in its own section below the grid.
     Dawn's filters/sorting replace #ProductGridContainer's HTML, so the row is re-placed after every re-render. */
  var GRID_AFTER = 4;
  function place(root) {
    if (root.__kDead) return;
    if (!root.__kHome) root.__kHome = root.parentElement; // the section's own wrapper
    var grid = document.getElementById('product-grid');
    var cards = grid ? $$(':scope > .grid__item:not(.k-look-slot)', grid) : [];
    var slot = grid ? $(':scope > .k-look-slot', grid) : null;
    if (cards.length <= GRID_AFTER) {
      if (root.parentElement !== root.__kHome) root.__kHome.appendChild(root);
      if (slot) slot.remove();
      return;
    }
    if (!slot) { slot = document.createElement('li'); slot.className = 'grid__item k-look-slot'; }
    if (cards[GRID_AFTER - 1].nextElementSibling !== slot) cards[GRID_AFTER - 1].after(slot);
    $$(':scope > [data-k-look]', slot).forEach(function (old) { if (old !== root) { old.__kDead = true; old.remove(); } }); // theme editor re-render
    if (root.parentElement !== slot) slot.appendChild(root);
  }
  var placeObs = null;
  function placeAll() {
    looks.forEach(function (l) { place(l.root); });
    var gridBox = document.getElementById('ProductGridContainer');
    if (gridBox && !placeObs && window.MutationObserver) {
      placeObs = new MutationObserver(function () { looks.forEach(function (l) { place(l.root); }); });
      placeObs.observe(gridBox, { childList: true, subtree: true });
    }
  }

  var looks = [];
  function scan() {
    $$('[data-k-look]').forEach(function (root) {
      if (root.__kLook) return;
      root.__kLook = new Look(root);
      looks.push(root.__kLook);
    });
    looks = looks.filter(function (l) { return l.root.isConnected && !l.root.__kDead; });
    placeAll();
  }

  window.KalveLook = { scan: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
